var React = require('react');

function AsanaTriangle (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","strokeWidth":"2","strokeMiterlimit":"10","d":"M27,35.99L18.5,23c5.75,0,6.508-0.368,6.935,2.625\n\tC25.639,27.06,27.25,37,27.25,37 M23.601,12.181c0.188,1.31-0.808,2.868-2.911,2.869c-9.355,0.001-11.516,1.064-13.257,4.438\n\tC5.338,23.545,2,37,2,37h2.063c0,0,6.951-12,7.736-12S24,37,24,37h6 M21.873,0.083l2.137,14.965C24.579,19.039,25.164,21,28,21\n\tc0.549,0,2.451,0,3,0c1.656,0,3-1.344,3-3s-1.344-3-3-3c-2.564,0-6.99,0.049-6.99,0.049"}));
}

AsanaTriangle.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"38px","height":"38px","viewBox":"0 0 38 38","enableBackground":"new 0 0 38 38","xmlSpace":"preserve"};

module.exports = AsanaTriangle;

AsanaTriangle.default = AsanaTriangle;
